import { render } from "./GestionEquipaje.vue?vue&type=template&id=66f5657d"
import script from "./GestionEquipaje.vue?vue&type=script&lang=js"
export * from "./GestionEquipaje.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__